module.exports = __webpack_public_path__ + "img/wx-login.1bf35d41.svg";